import './tickets_by_user_view.js.coffee'
Namespace 'Customer.Ticket'

class Customer.Ticket.ExternalTicketsByUserView extends Customer.Ticket.TicketsByUserView
  template: JST['backbone/templates/customer/ticket/external_tickets_by_user']
  className: 'external-tickets-by-user ticket-stats-box'
  events:
    'click .external-cases': 'showExternalCases'

  render: ->
    @$el.html @template
      thisUserHas: I18n.t('customer.dashboard.conversations.details.box.this_user_has')
      externalCases: @_externalCasesText()
      periodToCheck: @_periodToCheckMessage()
    @extendedUserProfile = new Profile.UserProfile.ExtendedUserProfile()
    @extendedUserProfile.getByTicket(@ticket).then @_renderTicketsModal
    @

  _externalCasesText: ->
    @_translatedCount('customer.dashboard.conversations.details.box.external_ticket', @_externalCasesCount())

  _externalCasesCount: ->
    @stats.external_tickets_in_period_count

  _renderTicketsModal: =>
    @ticketsModal = new Customer.Ticket.TicketsByUserModal
      extendedUserProfile: @extendedUserProfile
      periodToCheck: @stats.period_to_check
    @ticketsModal.fetchExternalTickets()
    @$el.append @ticketsModal.render().el

  showExternalCases: ->
    @ticketsModal.show(external: true)
